import type { FeatureFlagUser, IFeatureFlagsProvider } from './FeatureFlagsProvider'
import { createFeatureFlagsProvider } from './createFeatureFlagsProvider'

type FeatureFlagsClientFacade = {
  variation: (key: string, defaultValue: boolean) => boolean
  identify: (user: FeatureFlagUser) => void | Promise<void>
  allFlags: () => Record<string, boolean>
}

class FeatureFlagsService {
  private provider?: IFeatureFlagsProvider

  private readonly facade: FeatureFlagsClientFacade = {
    variation: (key: string, defaultValue: boolean) =>
      this.provider!.variation(key, defaultValue),
    identify: (user: FeatureFlagUser) => this.provider!.identify(user),
    allFlags: () => this.provider!.allFlags(),
  }

  getClient = () => this.facade

  getAllFlags = () => this.provider?.allFlags()

  public async init() {
    this.provider = createFeatureFlagsProvider()
    await this.provider.init()
  }
}

export default new FeatureFlagsService()
